import { GlossaryText } from './GlossaryText';

class FAQ {
  constructor(params) {
    this.id = params.id;
    this.name = params.name;
    this.questions = params.questions.map(question => (
      {
        question: question.question,
        answer: question.answer.map(answer => new GlossaryText(answer)),
      }
    ));
  }
}

export { FAQ };



// WEBPACK FOOTER //
// ./src/models/FAQ.js